import React from 'react';
import { teamMembers } from '../mockData';
import { Mail, Phone } from 'lucide-react';

const Team = () => {
  return (
    <div className="page-container">
      {/* Team Hero */}
      <section className="team-hero-section">
        <div className="container">
          <h1 className="heading-1">OUR TEAM</h1>
          <p className="body-large max-w-4xl">
            A collective of like-minded industry experts from India and abroad, bringing 
            together decades of experience in media, digital, technology, and strategic communication.
          </p>
        </div>
      </section>

      {/* Team Grid */}
      <section className="section-padding">
        <div className="container">
          <div className="team-grid">
            {teamMembers.map((member) => (
              <div key={member.id} className="team-card">
                <div className="team-card-image">
                  {member.image ? (
                    <img 
                      src={member.image} 
                      alt={member.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        objectPosition: 'center',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        background: '#302f2c'
                      }}
                    />
                  ) : (
                    <div className="team-placeholder">
                      <div className="team-initial">{member.name.charAt(0)}</div>
                    </div>
                  )}
                </div>
                <div className="team-card-content">
                  <h3 className="heading-4">{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                  <p className="caption team-focus">{member.focus}</p>
                  <p className="body-small team-bio">{member.bio}</p>
                  <div className="team-contact">
                    <a href={`mailto:${member.email}`} className="team-contact-link">
                      <Mail size={16} />
                      <span>Email</span>
                    </a>
                    <a href={`tel:${member.phone}`} className="team-contact-link">
                      <Phone size={16} />
                      <span>Call</span>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Values */}
      <section className="section-padding bg-card">
        <div className="container">
          <h2 className="heading-2 text-center mb-96">WHAT UNITES US</h2>
          <div className="team-values-grid">
            <div className="team-value-item">
              <h3 className="heading-5">Collective Expertise</h3>
              <p className="body-small">
                Diverse backgrounds spanning journalism, digital communication, broadcasting, 
                technology development, design strategy, and business leadership.
              </p>
            </div>
            <div className="team-value-item">
              <h3 className="heading-5">Global Perspective</h3>
              <p className="body-small">
                International experience with major global platforms including WSJ, Newsweek, 
                Gulf News, SPH, and direct market exposure across continents.
              </p>
            </div>
            <div className="team-value-item">
              <h3 className="heading-5">Strategic Thinking</h3>
              <p className="body-small">
                Combining creative storytelling with data-driven insights and technical 
                precision to deliver measurable business outcomes.
              </p>
            </div>
            <div className="team-value-item">
              <h3 className="heading-5">Ethical Practice</h3>
              <p className="body-small">
                Shared commitment to responsible communication, ethical AI integration, 
                and client-centric solutions that create lasting value.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Join Us */}
      <section className="join-section">
        <div className="container">
          <div className="join-content">
            <h2 className="heading-2">JOIN OUR TEAM</h2>
            <p className="body-large">
              We're always looking for talented professionals who share our values and 
              passion for building meaningful communication ecosystems.
            </p>
            <a href="mailto:connect@vaikunthamedia.com?subject=Career Opportunity" className="btn-primary">
              Explore Opportunities
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;
